﻿const Persons = {
  InternalName: "persons",
  Title: "Personen",
};

export const Public = {
  Persons: Persons,
};
